// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/WorkingTimeModelDayOfWeek.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/WorkingTimeModelDayOfWeek.proto.
 */
export const file_Enumerations_WorkingTimeModelDayOfWeek: GenFile = /*@__PURE__*/
  fileDesc("CixFbnVtZXJhdGlvbnMvV29ya2luZ1RpbWVNb2RlbERheU9mV2Vlay5wcm90bxIadGltZV90cmFja2luZy5lbnVtZXJhdGlvbnMqtgMKGVdvcmtpbmdUaW1lTW9kZWxEYXlPZldlZWsSNwolV09SS0lOR19USU1FX01PREVMX0RBWV9PRl9XRUVLX1NVTkRBWRAAGgzSx80PB1Nvbm50YWcSNgolV09SS0lOR19USU1FX01PREVMX0RBWV9PRl9XRUVLX01PTkRBWRABGgvSx80PBk1vbnRhZxI5CiZXT1JLSU5HX1RJTUVfTU9ERUxfREFZX09GX1dFRUtfVFVFU0RBWRACGg3Sx80PCERpZW5zdGFnEjsKKFdPUktJTkdfVElNRV9NT0RFTF9EQVlfT0ZfV0VFS19XRURORVNEQVkQAxoN0sfNDwhNaXR0d29jaBI8CidXT1JLSU5HX1RJTUVfTU9ERUxfREFZX09GX1dFRUtfVEhVUlNEQVkQBBoP0sfNDwpEb25uZXJzdGFnEjcKJVdPUktJTkdfVElNRV9NT0RFTF9EQVlfT0ZfV0VFS19GUklEQVkQBRoM0sfNDwdGcmVpdGFnEjkKJ1dPUktJTkdfVElNRV9NT0RFTF9EQVlfT0ZfV0VFS19TQVRVUkRBWRAGGgzSx80PB1NhbXN0YWdCKKoCJU1vZ2kuVGltZVRyYWNraW5nLkNvbW1vbi5FbnVtZXJhdGlvbnNiBnByb3RvMw", [file_Options_EnumValueOptions]);

/**
 * Specifies the day of week for a specific working time model.
 *
 * @generated from enum time_tracking.enumerations.WorkingTimeModelDayOfWeek
 */
export enum WorkingTimeModelDayOfWeek {
  /**
   * Represents the day sunday.
   *
   * @generated from enum value: WORKING_TIME_MODEL_DAY_OF_WEEK_SUNDAY = 0;
   */
  SUNDAY = 0,

  /**
   * Represents the day monday.
   *
   * @generated from enum value: WORKING_TIME_MODEL_DAY_OF_WEEK_MONDAY = 1;
   */
  MONDAY = 1,

  /**
   * Represents the day tuesday.
   *
   * @generated from enum value: WORKING_TIME_MODEL_DAY_OF_WEEK_TUESDAY = 2;
   */
  TUESDAY = 2,

  /**
   * Represents the day wednesday.
   *
   * @generated from enum value: WORKING_TIME_MODEL_DAY_OF_WEEK_WEDNESDAY = 3;
   */
  WEDNESDAY = 3,

  /**
   * Represents the day thursday.
   *
   * @generated from enum value: WORKING_TIME_MODEL_DAY_OF_WEEK_THURSDAY = 4;
   */
  THURSDAY = 4,

  /**
   * Represents the day friday.
   *
   * @generated from enum value: WORKING_TIME_MODEL_DAY_OF_WEEK_FRIDAY = 5;
   */
  FRIDAY = 5,

  /**
   * Represents the day saturday.
   *
   * @generated from enum value: WORKING_TIME_MODEL_DAY_OF_WEEK_SATURDAY = 6;
   */
  SATURDAY = 6,
}

/**
 * Describes the enum time_tracking.enumerations.WorkingTimeModelDayOfWeek.
 */
export const WorkingTimeModelDayOfWeekSchema: GenEnum<WorkingTimeModelDayOfWeek> = /*@__PURE__*/
  enumDesc(file_Enumerations_WorkingTimeModelDayOfWeek, 0);

